import { render, staticRenderFns } from "./BigImageComponent.vue?vue&type=template&id=c8518bae&scoped=true&"
import script from "./BigImageComponent.vue?vue&type=script&lang=js&"
export * from "./BigImageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8518bae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8518bae')) {
      api.createRecord('c8518bae', component.options)
    } else {
      api.reload('c8518bae', component.options)
    }
    module.hot.accept("./BigImageComponent.vue?vue&type=template&id=c8518bae&scoped=true&", function () {
      api.rerender('c8518bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/common/BigImageComponent.vue"
export default component.exports